import httpClient from '../utils/axios'
import {
    handleServiceError,
    handleServiceResponse,
} from '../utils/serviceResponseHelper'

async function getServiceAppList(processEngineServiceId) {
    return httpClient
        .get(
            `${window.config.SERVICE_MANAGEMENT_API_URL}/serviceApps/${processEngineServiceId}`
        )
        .then(response => {
            return handleServiceResponse(response)
        })
        .catch(error => handleServiceError(error))
}

async function getAvailableAppList(processEngineServiceId) {
    return httpClient
        .get(
            `${window.config.SERVICE_MANAGEMENT_API_URL}/apps/available/${processEngineServiceId}`
        )
        .then(response => {
            return handleServiceResponse(response)
        })
        .catch(error => handleServiceError(error))
}

async function createServiceApp({ processEngineServiceId, appId, url }) {
    const payload = {
        AppId: appId,
        Url: url,
    }

    return httpClient
        .post(
            `${window.config.SERVICE_MANAGEMENT_API_URL}/serviceapp/${processEngineServiceId}`,
            payload,
            {
                headers: { 'Content-Type': 'application/json' },
            }
        )
        .then(response => {
            return handleServiceResponse(response)
        })
        .catch(error => handleServiceError(error))
}

async function updateServiceApp({ serviceAppId, url }) {
    const payload = {
        Url: url,
    }

    return httpClient
        .put(
            `${window.config.SERVICE_MANAGEMENT_API_URL}/serviceapp/${serviceAppId}`,
            payload,
            {
                headers: { 'Content-Type': 'application/json' },
            }
        )
        .then(response => {
            return handleServiceResponse(response)
        })
        .catch(error => handleServiceError(error))
}

export default {
    getServiceAppList,
    getAvailableAppList,
    createServiceApp,
    updateServiceApp,
}
